module.exports = __webpack_public_path__ + "img/ios1.6be6275f.png";